var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2711 9.38701C18.2713 11.145 17.7502 12.8635 16.7736 14.3253C15.7971 15.7871 14.409 16.9264 12.7849 17.5993C11.1608 18.2721 9.3736 18.4482 7.6494 18.1053C5.92521 17.7624 4.34143 16.9158 3.09836 15.6728C1.85529 14.4297 1.00876 12.8459 0.665851 11.1217C0.322937 9.39752 0.499042 7.61036 1.17188 5.98625C1.84471 4.36214 2.98406 2.97403 4.44583 1.99748C5.90761 1.02093 7.62616 0.499802 9.38413 0.5C11.7411 0.5 14.0015 1.43632 15.6682 3.10295C17.3348 4.76959 18.2711 7.03003 18.2711 9.38701Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38321 0.474121L9.3592 0.499115C7.0877 2.90028 5.82296 6.08078 5.82521 9.38612V9.39612C5.82059 12.6958 7.07858 15.8723 9.3412 18.2741L9.3932 18.3291",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39305 18.3291L9.44505 18.2741C11.7015 15.8736 12.9557 12.7017 12.951 9.4071V9.3871C12.9507 6.08036 11.6823 2.89966 9.40704 0.500107L9.38306 0.475098",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.38721H18.275",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.84ad019be84462d05c3e9c57ff37dff1.svg";
export { ForwardRef as ReactComponent };